import lazyLoadOnRender from '@ms/yammer-web-components/dist/lazy/loadOnRender';

const AppHeader = () => import(/* webpackChunkName: "4-feat-appheader" */ './AppHeader');
export default lazyLoadOnRender({ loader: AppHeader });
